import * as segmentio from 'rp-analytics';

function getSubSectionFromURL() {
    const location = window.location.href;

    if (location.split('sales').length > 1) {
        const tabName = location.split('sales')[1];

        switch (tabName) {
            case '/search':
                return 'Sales Search';
            case '/my-shortlist':
                return 'My Shortlist';
            case '/statistics':
                return 'Sales Statistics';
            default:
                return 'Sales Catalogue';
        }
    }

    return 'Sales Catalogue';
}

export default function analyticsPage() {
    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Bloodstock',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: 'Sales',
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: getSubSectionFromURL(),
    });

    segmentio.page();
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js